import { createContext, useContext } from 'react';

import type { WorkspacePlanState } from '@/modules/billing/workspacePlan';

/** SDK-free view of Stigg, derived during render by BillingPlanProvider, not stored separately. */
export const WorkspacePlanContext = createContext<WorkspacePlanState>({
  plan: undefined,
  isLoading: false,
});

export const useWorkspacePlan = () => useContext(WorkspacePlanContext);
